import './infoModule.css'; // Create a CSS file for module-specific styling

export const InfoModule = ({ zoomScale }) => {

  return (
    <div className="info-module">
        <h2 id="info-module-title">Infobligations, une réalisation Arvester</h2>
        <div id="info-module-text">
            <p className="info-module-paragraph">
                Infobligations est une infographie interactive qui rassemble les obligations que doivent respecter les éditeurs de services audiovisuels en France.
            </p>
            <p className="info-module-paragraph">
              Dans une période de tensions réglementaires et de remise en question d'un modèle qui a longtemps fait la fierté des filières cinématographique et audiovisuelle, nous pensions qu'il était temps de dresser un état des lieux (d'entrée ou de sortie, selon le point de vue).
            </p>
            <p className="info-module-paragraph">
              Cette mise à plat se veut la plus neutre possible, mais pas pour autant exhaustive, dans la mesure où il nous a fallu simplifier certaines obligations pour les rendre intelligibles.
            </p>
            <p className="info-module-paragraph">
              Nous avons conscience que certaines informations peuvent être manquantes ou même erronées. Écrivez-nous à <a className="contact-email-address" href="mailto:contact@arvester.eu">contact@arvester.eu</a> pour signaler toute erreur et nous suggérer des modifications.
            </p>
        </div>
    </div>
  );
};